import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ApiCore } from 'src/app/config/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { EventMenuProfileService } from './profile-menu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.css'],
})
export class ProfileMenuComponent implements OnInit {
  public loading = true;
  public userName: string = '*********** *********';
  public showSecondProfileMenu: boolean = false;
  public awaitAnimationLobbyProfile: boolean = false;
  private routerSub!: Subscription;

  // @Input() showSecondProfileMenu: boolean = false;
  @Input() showProfileMenu: boolean = false;
  @Input() mobile: boolean = false;
  @Input() isPCPlayer: boolean = false;
  @Output() toggle = new EventEmitter();
  @Output() unlockScroll = new EventEmitter<void>();

  renderedComponent: boolean = false;

  constructor(
    private readonly api: ApiService,
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly eventMenuProfileService: EventMenuProfileService
  ) {
    this.listenEventMenu();
  }

  ngOnInit(): void {
    this.loadUserInfo();
    this.detectRoute(this.router.url);

    // Suscribirse a eventos de navegación
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log('🔙 Navegación detectada (posiblemente flecha atrás/adelante)');
        this.detectRoute(event.url);
      }
    });

    setTimeout(() => {
      this.renderedComponent = true;
    }, 600);
  }
  listenEventMenu() {
    this.eventMenuProfileService.$eventMenu.subscribe((e) => {
      this.openLobby();
    });
    this.eventMenuProfileService.$showProfile.subscribe((e) => {
      if (e) {
        this.openProfile();
      } else {
        this.openLobby();
      }
    });
  }
  private loadUserInfo(): void {
    this.api.list(ApiCore.USER + '/me').subscribe({
      next: (res) => {
        this.userName = res.data.userName;
        this.loading=false;
      },
      error: () => {
        console.error('Su sesión expiró o no ha iniciado sesión');
        // this.auth.destroySession();
      },
    });
  }

  public openProfile(): void {
    this.unlockScroll.emit();
    if (this.loggingOut) return;
    this.showSecondProfileMenu = true;
    this.delayAnimation(true);
    this.closeMenu();
    this.router.navigate(['/app/home/profile']);
    this.toggleMenu();
  }

  loggingOut: boolean = false;
  public logout(): void {
    if (this.loggingOut) return;
    this.loggingOut = true;

    this.eventMenuProfileService.closingSession(true);

    this.auth.logout().subscribe({
      error: (err) => console.error('Error during logout:', err),
    });

    this.showProfileMenu = false;
    this.auth.removeToken();

    this.router.navigate(['/app/home']);
    setTimeout(() => {
      this.openLobby();
      this.loggingOut = false;
      this.eventMenuProfileService.closeSesion();
      this.eventMenuProfileService.closingSession(false);
    }, 300);
  }

  public openLobby() {
    this.unlockScroll.emit();
    this.showSecondProfileMenu = false;
    this.delayAnimation(false);
    this.closeMenu();
    this.router.navigate(['/app/home']);
    this.toggleMenu();
  }

  public closeMenu() {
    // this.showProfileMenu = false;
  }
  toggleMenu() {
    this.toggle.emit();
    // this.showProfileMenu = !this.showProfileMenu;
  }

  private async delayAnimation(value: boolean) {
    setTimeout(() => {
      this.awaitAnimationLobbyProfile = value;
    }, 2500);
  }
  private detectRoute(fullUrl: string) {
    if (fullUrl.includes('profile')) {
      this.showSecondProfileMenu = true;
      this.awaitAnimationLobbyProfile = true;
    } else {
      this.showSecondProfileMenu = false;
      this.awaitAnimationLobbyProfile = false;
    }
  }

  ngOnDestroy(): void {
    if (this.routerSub) this.routerSub.unsubscribe();
  }
}
